<template>
  <div class="product-search" :class="className">
    <label>{{ title }}</label>
    <div class="product-search__container">
      <div class="product-search__search">
        <BaseIcon class="search__loupe" name="loupe"/>
        <input type="search" :placeholder="placeholder" v-model="searchQuery">
      </div>
      
      <LazyList
        :items="filteredItems" 
        class="product-search__list"
        :class="scrollAreaClassName"
        :scrollTopKey="searchQuery"
      >
        <template slot-scope="props">
          <RelationListItem
            class="list__item"
            :class="{ '-selected': item[key_value] == value }"
            v-for="item in props.items"
            :key="item[key_uid]"
            :label="item[key_label]"
            :image="getItemImage(item)"
            :popoverData="getPopoverData(item)"
          >
            <button slot="selectionHandler" class="list__select-btn" @click="select(item)">
              <BaseIcon :name="item[key_value] == value ? 'radio-selected' : 'radio-unselected'"/>
            </button>
          </RelationListItem>
        </template>
      </LazyList>
    
      <BaseSpinnerBig class="product-search__spinner" v-if="loading"/>
    </div>
  </div>
</template>

<script>
  import LazyList from '@/components/LazyList'
  import { get, isFunction } from 'lodash'
  import RelationListItem, { scrollAreaClassName } from '@/components/RelationListItem'
  import { PopoverDataModel } from '@/models/popover-data.model'
  import { getSearchbarPlaceholder } from '@/helpers'
  
  export default {
    components: {
      RelationListItem,
      LazyList,
    },

    props: {
      items: Array,
      value: [ String, Number ],
      title: String,
      loading: Boolean,

      key_uid: { default: 'key' },
      key_img: { default: 'featured_image' },
      key_label: { default: 'label' },
      key_img_second: { default: null },
      key_value: { default: 'id' }
    },
    data () {
      return {
        searchQuery: '',
        scrollAreaClassName
      }
    },
    computed: {
      className () {
        return {
          'product-search--loading': this.loading
        }
      },
      itemsForSearch () {
        if (Array.isArray(this.items)) {
          const res = []
          for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            const str = (item.handle || '') + ' ' + (item.id || '') + ' ' + (item[this.key_label] || '') + ' ' + (item.description || '')
            res.push(str.toLowerCase())
          }
          return res
        } else {
          return []
        }
      },
      filteredItems () {
        if (this.searchQuery) {
          const results = []
          const query = this.searchQuery.toLowerCase().trim()
          const indexes = []

          for (let i = 0; i < this.itemsForSearch.length; i++) {
            if (this.itemsForSearch[i].indexOf(query) > -1) {
              indexes.push(i)
            }
          }

          for (let i = 0; i < indexes.length; i++) {
            const idx = indexes[i]
            results.push(this.items[idx])
          }

          return results
        } else {
          return this.items || []
        }
      },
      placeholder () {
        return getSearchbarPlaceholder({ item: (this.items || [])[0] })
      }
    },
    methods: {
      select (item) {
        if (item[this.key_value] !== this.value) {
          this.$emit('input', item[this.key_value])
        }
      },
      getItemImage (item) {
        if (item[this.key_img] && !this.key_img_second) {
          return item[this.key_img]
        } else if (item[this.key_img] && this.key_img_second) {
          return item[this.key_img][this.key_img_second]
        } else {
          return ''
        }
      },
      getPopoverData (item) {
        return new PopoverDataModel({
          label: item[this.key_label],
          id: item.id,
          handle: item.handle,
          description: item.description,
        })
      }
    },
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/mixins.scss';
  @import './src/assets/styles/breakpoints.scss';

  .product-search {
    margin-bottom: 20px;
    
    label {
      display: block;
      margin-bottom: 5px;
      @include base-field-title;
    }

    &__search {
      display: flex;
      align-items: center;
      height: 32px;
      padding: 7px 10px;
      border-bottom: 1px solid $color-porcelain;
      color: $color-regent-gray;
      font-size: 14px;

      input {
        flex-grow: 1;
      }

      input::placeholder {
        color: $color-regent-gray;
      }

      .search__loupe {
        width: 14px;
        height: 14px;
        margin-right: 12px;
      }
    }
    
    &__container {
      position: relative;
      height: 295px;
      border: 1px solid $color-loblolly;
      border-radius: 3px;
      overflow: hidden;
    }

    &__list {
      height: calc(100% - 32px);
      transition: opacity .7s;

      .list__item {
        &.-selected {
          background-color: $color-athens-gray;
        }
      }

      .list__select-btn {
        margin-left: 20px;
        margin-right: 10px;

        svg {
          width: 20px;
          height: 20px;
        }
      }
    }

    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &--loading {
      .product-search__list {
        opacity: 0.5;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ProductSearch.vue